interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, currentPage - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const btn =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm transition";

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
        className={`${btn} bg-background-100 text-foreground-200 ring-1 ring-background-200/70 hover:text-accent-400 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onPageChange(page)}
          className={`${btn} ${
            page === currentPage
              ? "bg-accent-500 font-medium text-background-950"
              : "bg-background-100 text-foreground-200 ring-1 ring-background-200/70 hover:text-accent-400"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className={`${btn} bg-background-100 text-foreground-200 ring-1 ring-background-200/70 hover:text-accent-400 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}